import './VideoPermissionsModal.scss';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ModalComponent } from 'components/modal/modalComponent';
import DiagonalArrow from 'assets/images/diagonal-arrow.svg';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { FormattedText } from 'core/i18n';

export const VideoPermissionsModal = ({ showModal }) => {
    useEffect(() => {
        if (showModal) {
            window.scrollTo(0, 0);
            recordEventCustomOnly({
                categoriaEvento: 'onboarding/identidad/',
                accionEvento: 'modal/videoselfie-concede-permisos',
                etiquetaEvento: 'vista',
            });
        }
    }, [showModal]);

    return (
        <ModalComponent isOpen={showModal} className="modal-video-permissions">
            <img src={DiagonalArrow} alt="diagonal-arrow" className="modal-video-permissions__img" />
            <h1 className="modal-video-permissions__text modal-video-permissions__text--title">
                <FormattedText value={'identification-grantPermissionsModalTitle'} />
            </h1>
            <p className="modal-video-permissions__text modal-video-permissions__text--subtitle">
                <FormattedText value={'identification-grantPermissionsModalBody'} />
            </p>
        </ModalComponent>
    );
};

VideoPermissionsModal.propTypes = {
    showModal: PropTypes.bool,
};
